import { FadeUp } from "./Reveal";
import { STATS, IMAGES } from "../../lib/site";

export default function Stats() {
  return (
    <section className="relative py-28 lg:py-36 overflow-hidden" data-testid="stats-section">
      <img src={IMAGES.skyline} alt="Global reach" className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-[#030712]/85" />
      <div className="relative mx-auto max-w-[1400px] px-6 lg:px-10">
        <FadeUp className="mb-16 max-w-2xl">
          <span className="font-body text-xs tracking-[0.35em] text-[#00D166]">GLOBAL REACH</span>
          <h2 className="mt-4 font-display text-4xl md:text-6xl font-bold tracking-tight text-white">
            Measured in <span className="font-serifed italic font-normal text-white/70">outcomes.</span>
          </h2>
        </FadeUp>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
          {STATS.map((s, i) => (
            <FadeUp key={s.label} delay={i * 0.1}>
              <div className="bg-[#030712]/70 backdrop-blur-sm p-8 lg:p-12 h-full">
                <p className="font-display text-5xl lg:text-7xl font-extrabold text-[#00D166] tracking-tight">{s.value}</p>
                <p className="mt-4 font-body text-sm text-white/70 leading-relaxed">{s.label}</p>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
